var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{directives:[{name:"resize",rawName:"v-resize",value:(function () { return _vm.debouncedHandler(_vm.resizeChart); }),expression:"() => debouncedHandler(resizeChart)"}],staticClass:"ga-chart-wrapper"},[_c('div',{class:_vm.gaChartClasses},[_c('h6',[_vm._v("\n      "+_vm._s(_vm.$t('google-analytics') + ':')+"\n      "),_c('span',{staticClass:"ga-last-update",domProps:{"innerHTML":_vm._s(
          _vm.$t('ga-last-update', {
            domain: this.domain,
            date: this.lastUpdateDate,
          })
        )}})]),_vm._v(" "),_c('div',{ref:"gaHighcharts",attrs:{"id":"gaHighcharts"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }